import { module } from "../app";
import { safeApply } from "../services/safeApply";

module.directive("dropdownMenu", function ($rootScope, $window, $animate) {
  return {
    restrict: "E",
    templateUrl: "views/templates/dropdown.html",
    scope: {
      placeholder: "@",
      list: "=",
      selected: "=?",
      onSelectionChange: "&",
      onSelectedChanged: "&",
      onItemSelected: "&",
      onItemDeselected: "&",
      selectMode: "=",
      property: "@",
      key: "@",
      displayProperty: "@?",
      icon: "@",
      hideOtherDropdown: '=?',
      dropdownHeight: '=?',
      showCaret: '=?',
      alwaysPlaceholder: '=?',
      boldPlaceholder: '=?',
      disabled: '=?',
      emptyValue: '=?',
      isMultiSelect: '=?',
      width: '=?',
      hideCleanButton: '=?',
      hideSelectedValue: '=?',
      dropdownClass: "@",
    },
    require: '?ngModel',
    link: function (scope, element, ngModel) {
      scope.model = {
        selected: scope.selected,
        hideSelectedValue: scope.hideSelectedValue
      };

      let firstPart = Math.random().toString(36).substring(7);
      const className = firstPart + "-dropdown-menu-" + new Date().getTime();

      if (scope.emptyValue === undefined) {
        scope.emptyValue = '';
      }

      if (scope.model.selected === null
        || scope.model.selected === undefined) {
        scope.model.selected = scope.emptyValue;
      }

      if (scope.isMultiSelect) {
        scope.selectedItems = [];
        scope.multiSelectEvents = {
          onSelectionChanged: ($event) => {
            scope.model.selected = scope.selectedItems.map((elem) => elem[scope.key]).join(", ");
          },
          onItemDeselect: ($event) => {
            if (scope.onItemDeselected) {
              scope.onItemDeselected({ $type: $event });
            }
            
            scope.selected = scope.selectedItems.map((elem) => elem[scope.key]).join(", ");
          },
          onItemSelect: ($event) => {
            if (scope.onItemSelected) {
              scope.onItemSelected({ $type: $event });
            }
  
            scope.selected = scope.selectedItems.map((elem) => elem[scope.key]).join(", ");
          }
        };
        scope.multiselectSettings = {
          scrollableHeight: '200px',
          scrollable: true,
          dynamicTitle: true,
          showCheckAll: false,
          showUncheckAll: false,
          enableSearch: false,
          checkBoxes: true,
          displayProp: scope.property,
          idProperty: scope.key,
          smartButtonTextProvider(selectionArray) {
            const selectedValues = selectionArray.map((elem) => elem[scope.property]).join(", ");
            let cb = scope.onSelectionChange;
            if (cb) {
              cb({ $type: selectedValues });
            }
            return selectedValues;
          },
          template: `{{option.${scope.property}}}`,
        };
        if (scope.model.selected) {
          const selectedKeys = scope.model.selected.split(',');
          scope.selectedItems = scope.list.filter(item => selectedKeys.some(selectedKey => selectedKey.trim() === item[scope.key].trim()));
          scope.multiSelectEvents.onSelectionChanged();
        }
        scope.dropdownMultiSelectText = {
          buttonDefaultText: scope.placeholder
        };
      }

      $(element).addClass(className);

      scope.isSeparator = (item) =>
        (item[scope.property] && typeof item[scope.property] == 'string' && (item[scope.property].indexOf('----') > -1 || item[scope.property].indexOf('\\-') > -1)) || !!item["separator"];

      scope.onSelectedChange = ($item, $model) => {
        scope.model.selected = $model;
        if (scope.model.selected === null
          || scope.model.selected === undefined) {
          scope.model.selected = scope.emptyValue;
        }

        if (scope.selected !== scope.model.selected){
          scope.selected = scope.model.selected;
        }

        let cb = scope.onSelectionChange;
        if (cb) {
          cb({ $type: scope.model.selected });
        }
      };

      scope.resetSelectedClick = ($event, $select) => {
        if (scope.disabled === true) {
          return;
        }

        scope.model.selected = scope.emptyValue;
        if (scope.isMultiSelect) {
          scope.selectedItems = [];
          scope.multiSelectEvents.onSelectionChanged();
        }

        if ($select) {
          $event.stopPropagation();
          $event.preventDefault();
          const defaultValue = scope.list.find(item => item[scope.key] === scope.emptyValue);
          $select.selected = defaultValue;
        }

        if (scope.selected !== scope.model.selected) {
          scope.selected = scope.model.selected;
        }

        let cb = scope.onSelectionChange;
        if (cb) {
          cb({ $type: scope.model.selected });
        }
      };

      scope.$watch('selected', function (newValue) {
        if (scope.model.selected !== newValue) {
          scope.model.selected = newValue;          
        }
      }, true);

      scope.$watch('model.selected', function () {
        if (scope.model.selected === 0) {
          let keyVal = scope.key;
          let result = _.find(scope.list, { keyVal: scope.model.selected });
          if (result === undefined) {
            scope.model.selected = scope.emptyValue;
          }        
        }
        
        if(scope.onSelectedChanged) {
          scope.onSelectedChanged({selected: scope.model.selected});
        }
      }, true);
    }
  };
});


// WEBPACK FOOTER //
// ./src/scripts/directives/dropdownMenu.js